const cards = [
  {
    title: '暑期档必看：2025最受期待的十部国产大片',
    desc: '从科幻巨制到现实主义题材，暑期档电影市场百花齐放，我们为你整理了最值得关注的十部作品。',
    tag: '影评推荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Summer%20movie%20theater%20exterior%20at%20golden%20hour%20with%20warm%20sunset%20lighting%2C%20cinema%20marquee%20with%20film%20posters%2C%20urban%20street%20scene%2C%20entertainment%20district%20atmosphere%2C%20professional%20photography&width=720&height=480&seq=card-01&orientation=landscape',
  },
  {
    title: '西瓜视频免费专区使用方法全攻略',
    desc: '手把手教你如何在西瓜视频免费专区找到心仪内容，从搜索技巧到分类浏览，助你畅享观影体验。',
    tag: '使用指南',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20living%20room%20with%20large%20TV%20screen%20displaying%20streaming%20interface%2C%20cozy%20home%20entertainment%20setup%2C%20warm%20ambient%20lighting%2C%20comfortable%20viewing%20environment%2C%20professional%20interior%20photography&width=720&height=480&seq=card-02&orientation=landscape',
  },
  {
    title: '91在线视频十大经典港片回顾特辑',
    desc: '重温那些年我们追过的港片经典，从武侠到警匪，从喜剧到爱情，每一部都是满满的回忆。',
    tag: '经典回顾',
    imageUrl: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20cityscape%20at%20night%20with%20neon%20signs%20and%20wet%20streets%2C%20cinematic%20mood%2C%20vintage%20film%20aesthetic%2C%20warm%20neon%20glow%20on%20dark%20streets%2C%20atmospheric%20urban%20photography&width=720&height=480&seq=card-03&orientation=landscape',
  },
  {
    title: '如何选择适合你的追剧节奏？观影时间管理指南',
    desc: '面对海量影视内容，合理安排追剧时间很重要。我们提供几条实用建议，帮你更好地规划观影计划。',
    tag: '观影技巧',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20warm%20lighting%20and%20tablet%20device%2C%20minimalist%20home%20setup%2C%20calm%20and%20peaceful%20atmosphere%2C%20soft%20shadows%2C%20lifestyle%20photography%20with%20warm%20tones&width=720&height=480&seq=card-04&orientation=landscape',
  },
  {
    title: '从弹幕文化到影视社区：在线观影社交新趋势',
    desc: '弹幕互动正在改变我们观看影视的方式。69视频平台打造全新的观影社交体验，边看边聊更有趣。',
    tag: '行业观察',
    imageUrl: 'https://readdy.ai/api/search-image?query=Social%20media%20and%20streaming%20concept%20with%20floating%20interface%20elements%2C%20abstract%20digital%20communication%20visual%2C%20dark%20background%20with%20colorful%20chat%20bubbles%2C%20modern%20tech%20aesthetic%2C%20professional%20design&width=720&height=480&seq=card-05&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-500/10 border border-secondary-500/20 mb-4">
            <span className="text-xs text-secondary-400 whitespace-nowrap">精选内容</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-50 mb-3">图文推荐</h2>
          <p className="text-sm text-foreground-400 max-w-xl mx-auto">
            精选影视推荐、观影指南与行业资讯，丰富你的观影生活
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.slice(0, 3).map((card) => (
            <div key={card.title} className="group bg-background-200/60 rounded-xl overflow-hidden hover:bg-background-200 transition-colors cursor-pointer">
              <div className="aspect-[3/2] bg-background-300 overflow-hidden">
                <img
                  src={card.imageUrl}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2 py-0.5 rounded text-[10px] font-medium bg-accent-500/20 text-accent-400 mb-3 whitespace-nowrap">
                  {card.tag}
                </span>
                <h3 className="text-base font-medium text-foreground-200 mb-2 group-hover:text-primary-400 transition-colors leading-snug">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}

          {cards.slice(3).map((card) => (
            <div key={card.title} className="group bg-background-200/60 rounded-xl overflow-hidden hover:bg-background-200 transition-colors cursor-pointer sm:col-span-2 lg:col-span-2">
              <div className="flex flex-col sm:flex-row">
                <div className="sm:w-2/5 aspect-[3/2] sm:aspect-auto bg-background-300 overflow-hidden">
                  <img
                    src={card.imageUrl}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="sm:w-3/5 p-5 flex flex-col justify-center">
                  <span className="inline-block px-2 py-0.5 rounded text-[10px] font-medium bg-accent-500/20 text-accent-400 mb-3 whitespace-nowrap self-start">
                    {card.tag}
                  </span>
                  <h3 className="text-base font-medium text-foreground-200 mb-2 group-hover:text-primary-400 transition-colors leading-snug">
                    {card.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {card.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}